import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgExclamationCircle = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 12 12"
    ref={ref}
    {...props}
  >
    <g clipPath="url(#exclamation-circle_svg__a)">
      <path
        fill="currentColor"
        d="M6 0C2.685 0 0 2.685 0 6s2.685 6 6 6 6-2.685 6-6-2.685-6-6-6m-.663 3.05h1.326v3.712H5.337zM6 8.95a.665.665 0 0 1-.663-.663c0-.364.298-.663.663-.663s.663.299.663.663A.665.665 0 0 1 6 8.95"
      />
    </g>
    <defs>
      <clipPath id="exclamation-circle_svg__a">
        <path fill="currentColor" d="M0 0h12v12H0z" />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgExclamationCircle);
export default ForwardRef;
